import Text from '@deprecated-ui/common/Text';
import ButtonAntd from '@deprecated-ui/common/Button';
import ModalAntd from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const Button = styled(ButtonAntd)`
  border-radius: 3px;
  height: 44px;
  &:not(:first-child) {
    margin-left: 20px !important;
  }
`;

const Modal = styled(ModalAntd).attrs({
  zIndex: 1031, // To Overlap Popover StreamItemOption
  width: 400,
  centered: true,
})`
  .ant-modal-close-x {
    display: none;
  }
  .ant-modal-content {
    border-radius: 3px;
  }
  .ant-modal-header {
    padding: 0 20px !important;
    height: 54px;
    border-color: ${color.gainsboro};
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .ant-modal-title {
    p {
      text-align: center;
    }
  }
  .ant-modal-close-x {
    & > img {
      width: 15px;
      height: 15px;
    }
  }
  .ant-modal-body {
    padding: 0 20px 20px 20px;
  }
  .ant-modal-footer {
    padding: 20px;
    text-align: left;
    display: flex;
  }
`;

const ModalText = styled(Text)`
  white-space: pre-wrap;
`;

export { Modal, Button, ModalText };
